import React from 'react'
import CMSMenuWithLayout from './CMSMenuWithLayout';
import Privateevent from '../Allmenus/Thrdmenu/Privateevent'
import Img from '../../assets/images/background/banner-image-2.jpg'

function Menuthree() {
  return (
    <>
      <CMSMenuWithLayout
        categoryFilter="hot-appetizers"
        title="APPETIZERS & STARTERS"
        subtitle="Perfect for Sharing"
        bannerImage={Img}
        showOffers={true}
        showReservation={false}
      />
      <Privateevent />
    </>
  )
}

export default Menuthree